
import SGBPCategoryList from "../../features/CategoryCriteriaCertificateMapping/CategoryCriteriaCertificateMappingList";
import "./SGBPCategory.scss";

const SGBPCategory = () => {
  return (
    <div>
      <SGBPCategoryList />
    </div>
  );
};

export default SGBPCategory;
